import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, Typography } from '@blade/ui-kit'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { openTradeSettingsDialogEvent } from '@root/features/trade/trade-settings/atoms'
import { ArrowLeftIcon, Gear2Icon } from '@root/shared/ui-kit/icons'

import type { WalletModel } from '@root/entities/wallet/atoms'

type WalletSwapHeaderProps = {
  wallet: WalletModel
  onBack: () => void
}

export const WalletSwapHeader: React.FC<WalletSwapHeaderProps> = ({
  wallet,
  onBack,
}) => {
  const { t } = useTranslation()
  const openSettings = useAction(openTradeSettingsDialogEvent)

  return (
    <Root>
      <Button
        variant="secondary"
        size="h32"
        iconLeft={<ArrowLeftIcon />}
        onClick={onBack}
      />
      <TitleContainer>
        <Title variant="description-semi-bold">{t('swap')}</Title>
        <WalletModelShort size="md" wallet={wallet} />
      </TitleContainer>
      <Button
        size="h32"
        variant="secondary"
        iconLeft={<Gear2Icon />}
        onClick={() => openSettings({})}
      ></Button>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  padding-block: 16px 16px;
`

const Title = styled(Typography)`
  color: var(--text-9);
  text-align: center;
  text-transform: uppercase;
`

const TitleContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  gap: 2px;
`
